let error = 0;
let errortext =0;
let index =0;

const divs = document.querySelectorAll('.change-tab');

divs.forEach(el => el.addEventListener('click', event => {
	index = event.target.getAttribute("data-id");
	requiredFields(index);
	$('.btn-tab').removeClass('active');
	$('.btn-tab').eq(index).addClass('active');
	$('.show-hide').hide();
	$('.show-hide').eq(index).show();

}));


let requiredFields = (e) => {
	error = '0';
	if (e > 0) {
		for(let j=0; j < e; j++){
			let divid = 'div' + j;
			let formtab = document.getElementById(divid);
			let inputs = formtab.querySelectorAll("input");
			for(let i=0; i < inputs.length; i++){
				if (inputs[i].type == 'email'){
					if (/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(inputs[i].value)) {
						inputs[i].style.borderColor = 'transparent';

						var inputVal = inputs[i].value; 
						if(inputVal.indexOf("@globaltransportcompany.com")>-1){
							inputs[i].style.border = "1px solid red";
							if (errortext == '0') {
								let z = document.createElement('span'); 
								z.innerHTML = 'Please fill all the required fields.';
								document.querySelector('.success-err-msg').appendChild(z);
								errortext = 1;
							}
							error = 1;
						}
					} else {
						inputs[i].style.border = "1px solid red";
						if (errortext == '0') {
							let z = document.createElement('span'); 
							z.innerHTML = 'Please fill all the required fields.';
							document.querySelector('.success-err-msg').appendChild(z);
							errortext = 1;
						}
						error = 1;
					}
				} else if (inputs[i].type == 'tel') {
					if (/^(\+)?(\(\d{2,3}\) ?\d|\d)(([ \-]?\d)|( ?\(\d{2,3}\) ?)){8,12}\d$/i.test(inputs[i].value)) {
						inputs[i].style.borderColor = 'transparent';
					} else {
						inputs[i].style.border = "1px solid red";
						if (errortext == '0') {
							let z = document.createElement('span'); 
							z.innerHTML = 'Please fill all the required fields.';
							document.querySelector('.success-err-msg').appendChild(z);
							errortext = 1;
						}
						error = 1;
					}
				} else if (inputs[i].type == 'checkbox' && inputs[i].hasAttribute('required')) {
					console.log('Checkbox required');
					console.log(inputs[i].checked);
					if (inputs[i].checked) {
						inputs[i].classList.remove('error-border');
					} else {
						inputs[i].classList.add('error-border');
						if (errortext == '0') {
							let z = document.createElement('span'); 
							z.innerHTML = 'Please fill all the required fields.';
							document.querySelector('.success-err-msg').appendChild(z);
							errortext = 1;
						}
						error = 1;
					}
				} else {
					if (inputs[i].value === '' && inputs[i].hasAttribute('required')) {
						inputs[i].style.border = "1px solid red";
						if (errortext == '0') {
							let z = document.createElement('span'); 
							z.innerHTML = 'Please fill all the required fields.';
							document.querySelector('.success-err-msg').appendChild(z);
							errortext = 1;
						}
						error = 1;
					} else {
						inputs[i].style.borderColor = '1px solid #000';
					}
				}
			}
			if (error == 0 && errortext == '1') {
				document.querySelector('.success-err-msg span').remove();
				errortext = 0;
			}
			if (error == '1') {
					index = j;
					break;
			}
		}
	}


}


let sub = (e) => {
	let file = e.value;
	let fileName = file.split("\\");
	e.parentElement.querySelector('span').innerHTML = fileName[fileName.length - 1];
}

$('.fb-submit .button-input').click(function() {
	ga('send', {
      hitType: 'event',
      eventCategory: 'SellTradeForm',
      eventAction: 'SubmitForm'
    });
});

window.addEventListener('DOMContentLoaded', function() {    
	$(document).ready(function() {
		$('.submit .form-submit-btn-wrap button[type="submit"]').on( "click", function() {
			var refreshInterval = setInterval(check_success_message, 500);

			 function check_success_message(){
				if($('.alert-success').length){
					ga('send', {
						hitType: 'event',
						eventCategory: 'BridalForm',
						eventAction: 'SubmitForm',
						eventLabel: 'CustomDesign',
						eventValue: '1'
					  });
					clearInterval(refreshInterval);
				}
			}
		});


	});
});